(function() {
	'use strict';

	angular.module('gatewayApp').controller('ForexConfigurationsViewController',
        ForexConfigurationsViewController);

            ForexConfigurationsViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'ForexConfigurations', 'entity',
			'Workflow', 'GlobalValues','StaticLookUp'];

	function ForexConfigurationsViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, ForexConfigurations, entity, Workflow,
			GlobalValues,StaticLookUp) {
		var vm = this;
		vm.clear = clear;
		vm.approveForexConfigurations = approveForexConfigurations;
		vm.rejectForexConfigurations = rejectForexConfigurations;
		vm.discardForexConfigurations = discardForexConfigurations;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseRedirectionURLConfigurations = false;
		vm.ExpandOrCollapseFeeConfigurations = false;
		vm.globalValues = GlobalValues;
		vm.forexConfigurationsDTO = {};
        vm.bankValue=null;
        vm.bank=null;
        vm.state=null;

		if (workflowSharedService.viewFrom == 'forexConfigurations') {
			vm.forexConfigurations = entity; 
			console.log(vm.forexConfigurations); 
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'forex_configurationstodolist_checker') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);

			if (vm.forexConfigurations  == undefined) {
				vm.forexConfigurations = vm.forexConfigurationsDTO
			}
			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'forex_configurationstodolist_maker') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);
			if (vm.forexConfigurations == undefined ||vm.forexConfigurations == null) {
				vm.forexConfigurations =  vm.forexConfigurationsDTO
			}
			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'forexConfigurations_auditLog') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);
		

			if (vm.forexConfigurations == undefined) {
				vm.forexConfigurations = vm.forexConfigurationsDTO
			}
			$scope.showButton = false;
		}
		
		function approveForexConfigurations() {
			ForexConfigurations.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectForexConfigurations() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardForexConfigurations() {
			ForexConfigurations.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
